import React, { useContext, useState } from 'react'
import MessageContext from '../../../../context/MessageContext';
import ChatBubble from '../ChatBubble/ChatBubble'
import ChatHeader from '../ChatHeader/ChatHeader'
import api from '../../../../services/axisoHttp';
import { API } from '../../../../constants/API';
import styles  from './Chat.module.scss';
import AppDataContext from '../../../../context/AppDataContext';

interface ChatProps {
  closeHandler?: any;
}

export default function Chat({ closeHandler } : ChatProps) {
  const { user }: any = useContext(AppDataContext);
  const { chat, setChat, chatLogs, setChatLogs }: any =
    useContext(MessageContext);
  const [composeMessage, setComposeMessage] = useState("");

  const sendMessage = async (e: any) => {
    e.preventDefault();

    let newMessage = {
      ...user,
      time: "1 second ago",
      messages: composeMessage,
    };
    let resChat = chat;
    resChat.messages.push(newMessage);
    setChat(resChat);

    let newChatLogs = chatLogs.map((chatLog: any) => {
      if (chatLog.id === chat.id) {
        chatLog = resChat;
      }
      return chatLog;
    });

    setChatLogs(newChatLogs);
    setComposeMessage("");

    // try{
    //     const response = await api.put(`${API.MESSAGES}/${chat.id}`, {
    //       ...chat,
    //       messages: [...chat.messages, newMessage]
    //     })
    //     if(response && response.data) {
    //       console.log(response.data)
    //       // Update current message
    //       setChat(response.data);

    //       // Update on all chatLog state
    //       let newChatLogs = chatLogs.map((chatLog: any) =>{
    //         if(chatLog.id === chat.id){
    //           chatLog = response.data;
    //         }
    //         return chatLog
    //       })

    //       setChatLogs(newChatLogs);
    //       setComposeMessage('')
    //     }
    // } catch(err){
    //     // Not in the 200 response
    //     console.log(err)
    // }
  };

  return (
    <div className={styles.chatRoom}>
      <ChatHeader closeHandler={closeHandler} />

      <section className={styles.chatList}>
        {chat?.messages?.map((message: any, i: number) => (
          <ChatBubble chat={message} key={i} />
        ))}
      </section>

      <form className={styles.chatForm} onSubmit={sendMessage}>
        <input
          autoComplete="false"
          value={composeMessage}
          onInput={(e: any) => setComposeMessage(e.target.value)}
          placeholder="Message"
          className="form-control"
        />

        <button className="btn-secondary" type="submit">
          <span className="icon-send"></span>
        </button>
      </form>
    </div>
  );
}
